module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("AH-Zirkel " + _vm._s(_vm.zirkel))]), _vm._v(" "), _vm._l((_vm.berechtigt), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n      ")])
  })], 2), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Zirkel-Mitglieder (" + _vm._s(_vm.mitglieder.length) + ")")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "450px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Vorname")]), _vm._v(" "), _c('th', [_vm._v("Nachname")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.mitglieder), function(mitglied) {
    return _c('tr', {
      key: mitglied.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = mitglied) && (_vm.showKontakt = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(mitglied.nachname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mitglied.vorname))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                (_vm.bbr = mitglied) && (_vm.showRemoveKontakt = true)
              }
            }
          }, on), [_c('v-icon', [_vm._v("person_remove")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Bbr aus Zirkel entfernen")])])], 1)])
  }), 0)]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-xs-only"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAddKontakt = true
      }
    }
  }, [_vm._v("Bundesbruder hinzufügen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('veranstaltungenListe', {
    attrs: {
      "kalender": 'AH-Zirkel ' + _vm.zirkel,
      "hideImage": true,
      "anzahl": "15"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-space-between"
  }, [_vm._v("\n          Gesendete Mails\n          "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueMail = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": ""
    }
  }, [(_vm.nachrichten.length === 0) ? _c('v-subheader', {
    staticClass: "justify-center"
  }, [_vm._v("\n            Keine Rundmails versendet.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nachrichten), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          (_vm.nachricht = item) && (_vm.showMail = true)
        }
      }
    }, [(item.status === 'Error' && item.status) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("warning")])], 1) : _vm._e(), _vm._v(" "), (item.status === 'Entwurf' && item.status) ? _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "loading": "",
        "disabled": "",
        "text": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "font-weight-bold"
    }, [(item.absender.position) ? _c('span', [_vm._v(_vm._s(item.absender.position))]) : _vm._e(), _vm._v(" "), (item.absender.name) ? _c('span', [_vm._v(_vm._s(item.absender.name))]) : _vm._e(), _vm._v(" "), (item.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(item.von, _vm.bbrbbr)))]) : _vm._e()]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                  " + _vm._s(item.message.subject) + "\n                ")])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "text-right"
    }, [_vm._v("\n                " + _vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY"))), _c('br'), _vm._v("\n                " + _vm._s(_vm.$filters.date(item.datum, "hh:mm")) + " Uhr\n              ")])], 1), _vm._v(" "), (index + 1 !== _vm.nachrichten.length) ? _c('v-divider') : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-xs-only"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "to": "./mail",
      "text": ""
    }
  }, [_vm._v("Alle Mails")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogMail', {
    attrs: {
      "visible": _vm.showMail,
      "nachricht": _vm.nachricht
    },
    on: {
      "update:visible": function($event) {
        _vm.showMail = $event
      },
      "close": function($event) {
        _vm.showMail = false
      }
    }
  }), _vm._v(" "), _c('dialogMailNeu', {
    attrs: {
      "visible": _vm.showNeueMail
    },
    on: {
      "update:visible": function($event) {
        _vm.showNeueMail = $event
      },
      "close": function($event) {
        _vm.showNeueMail = false
      }
    }
  }), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showRemoveKontakt,
      "title": "Bbr aus Zirkel entfernen",
      "message": 'Willst du Bbr ' + _vm.bbr.nachname + ' wirklich aus dem Zirkel entfernen?',
      "abbrechen": "Abbrechen",
      "weiter": "Entfernen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showRemoveKontakt = $event
      },
      "closeTrue": function($event) {
        return _vm.removeBbrFromZirkel()
      },
      "closeFalse": function($event) {
        _vm.showRemoveKontakt = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAddKontakt),
      callback: function($$v) {
        _vm.showAddKontakt = $$v
      },
      expression: "showAddKontakt"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Bbr dem Zirkel hinzufügen ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.bbrbbrselect,
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.bbr),
      callback: function($$v) {
        _vm.bbr = $$v
      },
      expression: "bbr"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAddKontakt = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.addBbrToZirkel()
      }
    }
  }, [_vm._v("hinzufügen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05cbc66e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/zirkel.vue
// module id = 731
// module chunks = 15